export const ENVIRONMENT = {
    dev: 'dev',
    production: 'prod',
    staging: 'stg',
    qa: 'qa',
    local: 'local',
};

export const USER_TYPE = {
    restaurant: 'restaurant',
    consumer: 'consumer',
};
